import { newRequest, oldRequest } from "./complexRequest"
import { ComplexRequestOption, ResponseType } from "./type"

// 获取价格表
export const getGoodsInfo = async (
  params?: any,
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return newRequest<ResponseType>({
    url: '/client/common/query/goods',
    params,
    method: 'get',
    ...option
  }, useFetch)
}


// 填写邀请code
export const redeemCode = async (
  data?: { code: string, user_id: number },
  option?: ComplexRequestOption,
  useFetch = true) => {
  return oldRequest<ResponseType<any>>({
    url: '/Api/User/redeem',
    data,
    method: 'post',
    ...option
  }, useFetch)
}

export type PaypalSubscribePayload = {
  goods_id: number
  upgrade_confirm?: string
}

export type PaypalSubscribeData = {
  status: number
  link?: string
  action?: string
  upgrade_confirm?: string
}

// 订阅
export const subscribe = async (
  data?: PaypalSubscribePayload,
  option: ComplexRequestOption = {},
  useFetch = true) => {
  return newRequest<ResponseType<PaypalSubscribeData>>({
    url: '/client/payment/paypal-subscribe',
    data,
    method: 'post',
    ...option
  }, useFetch)
}



// 购买能量
export const buy = async (
  data?: { goods_id: number },
  option: ComplexRequestOption = {},
  useFetch = true) => {
  return newRequest<ResponseType>({
    url: '/client/payment/paypal-buy',
    data,
    method: 'post',
    ...option
  }, useFetch)
}


// payssion 订阅 (俄罗斯)
export const payssionSubscribe = async (
  params: { goods_id: number },
  option: ComplexRequestOption = {},
  useFetch = true) => {
  return newRequest<ResponseType>({
    url: '/client/payment/payssion-mandate',
    params,
    method: 'get',
    ...option
  }, useFetch)
}

// payssion 购买能量 (俄罗斯)
export const payssionBuy = async (
  params?: { goods_id: number },
  option: ComplexRequestOption = {},
  useFetch = true) => {
  return newRequest<ResponseType>({
    url: '/client/payment/payssion-buy',
    params,
    method: 'get',
    ...option
  }, useFetch)
}